import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import useDebouncedSearch from "hooks/useDebouncedSearch";
import { useTranslation } from "react-i18next";
import { PageContainer } from "@outpave/ds";
import AccountType from "enums/AccountType";
import useGetBankAccounts, { BankAccount } from "hooks/useGetBankAccounts";
import FinancialAccountsDropdown, {
  ALL_ACCOUNTS_OPTION,
} from "components/common/FinancialAccountsDropdown";
import StatementsTable from "../../components/admin/statements/StatementsTable";

export const STATEMENTS_TABS = {
  STATEMENTS: { id: "statements", label: "Statements" },
};

const Statements: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const search = useDebouncedSearch(setSearchTerm);

  // The accounts panel links here for one program's statements.
  const linkedState = location.state as { accountId?: string } | null;
  const [accountId, setAccountId] = useState<string>(
    linkedState?.accountId ?? ALL_ACCOUNTS_OPTION.id,
  );

  const bankAccounts = useGetBankAccounts({
    accountTypes: [AccountType.FINANCIAL_ACCOUNT],
    withBalances: false,
  });
  const showAccountFilter = bankAccounts.internalAccounts.length > 1;

  const tabConfigurations = [STATEMENTS_TABS.STATEMENTS];

  return (
    <PageContainer
      title={t("Statements")}
      tabs={{
        items: tabConfigurations.map((tab, index) => ({
          id: String(index),
          label: t(tab.label),
        })),
        activeId: String(activeTab),
        onChange: (id) => setActiveTab(Number(id)),
      }}
      search={search}
      filters={
        showAccountFilter ? (
          <FinancialAccountsDropdown
            value={accountId}
            onChange={(account: BankAccount | null) =>
              setAccountId(account?.id ?? ALL_ACCOUNTS_OPTION.id)
            }
            accountTypes={[AccountType.FINANCIAL_ACCOUNT]}
            accounts={bankAccounts}
            includeAllOption
          />
        ) : undefined
      }
    >
      <StatementsTable
        searchTerm={searchTerm}
        accountId={accountId === ALL_ACCOUNTS_OPTION.id ? undefined : accountId}
      />
    </PageContainer>
  );
};

export default Statements;
